// 💾 src/components/trade/OrderBook.tsx
import { useBinanceSocket } from "../../hooks/useBinanceDeepth"

type Props = { pair: string }

const OrderBook = ({ pair }: Props) => {
  const depth = useBinanceSocket(pair, "depth") as { bids: [string, string][], asks: [string, string][] }

  return (
    <div className="orderbook">
      <div className="orderbook-table">
        <table>
          <thead>
            <tr><th>Price</th><th>Amount</th></tr>
          </thead>
          <tbody>
            {[...depth.asks].reverse().map(([price, qty]: [string, string]) => (
              <tr key={price} className="sell">
                <td>{parseFloat(price).toFixed(4)}</td>
                <td>{parseFloat(qty).toFixed(4)}</td>
              </tr>
            ))}
            {depth.bids.map(([price, qty]: [string, string]) => (
              <tr key={price} className="buy">
                <td>{parseFloat(price).toFixed(4)}</td>
                <td>{parseFloat(qty).toFixed(4)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default OrderBook
